// TODO switch to redux-toolkit selectors
import { useCallback } from 'react';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from '../services/store';
import { api } from '../services/api';
import { AuthContextGroup, Role, useCallbackInterface } from '../interfaces/auth.interface';

interface AuthContextInterface {
  isAuthenticated: boolean;
  email: string | null;
  userId: string | null;
  group: AuthContextGroup | null;
  login: useCallbackInterface;
  logout: () => void;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  isGroupAdmin: boolean;
}

function checkIsAdmin(role: Role | null) {
  return role === Role.ADMIN || role === Role.SUPERADMIN;
}

function checkIsSuperAdmin(role: Role | null) {
  return role === Role.SUPERADMIN;
}

function checkIsGroupAdmin(adminGroups: string[] | null) {
  if (!adminGroups) {
    return false;
  }
  return adminGroups.length > 0;
}

export const useAuth = (): AuthContextInterface => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);

  // TODO void?
  const login = useCallback<useCallbackInterface>(() => {}, []);
  const logout = () => dispatch(api.endpoints.logout.initiate());

  return {
    login,
    logout,
    userId: user.userId,
    group: user.group,
    email: user.email,
    isAuthenticated: user.isAuthenticated,
    isAdmin: checkIsAdmin(user.role),
    isSuperAdmin: checkIsSuperAdmin(user.role),
    isGroupAdmin: checkIsGroupAdmin(user.adminGroup)
  };
};
